import React from 'react';
import { labelValue } from '../Helpers';

interface HoofdfinancierderBoxProps {
    title: string;
    project: {
        mainFundingChannel: {
            id: string;
            modelType: string;
            name: string;
            code: string;
        }
        mainDetailedFundingChannel: {
            id: string;
            modelType: string;
            name: string;
        } | null;
        mainFunderAccount: {
            name: string;
        }
        mainFunderContact: {
            name: string;
        }
    }
}

const HoofdfinancierderBox = ({ title, project } : HoofdfinancierderBoxProps)  => {
    return (
        <div className='box'>
            <h3>{title}</h3>
            <div className='items'>
                {labelValue(project?.mainFundingChannel?.name, "Financiëringskanaal")}
                {labelValue(project?.mainDetailedFundingChannel?.name ?? "", "Gedetailleerd Financieringskanaal")}
                {labelValue(project?.mainFunderAccount?.name, "Account")}
                {labelValue(project?.mainFunderContact?.name, "Contactpersoon")}
            </div>
        </div>
    );
};

export default HoofdfinancierderBox;
